import { webLogger, logger } from '@/common/log';

export function sendListPv() {
    webLogger.sendLog({
        type: 'pv',
        name: 'THIRD_PARTY_PLATFORM_AUTHORIZATION',
    });
}

export function sendItemClick(client_name) {
    webLogger.sendLog({
        type: 'click',
        name: 'AUTHORIZE_LIST',
        value: {
            client_name,
        },
    });
}

export function sendDeAuthorizeClick() {
    webLogger.sendLog({
        type: 'click',
        name: 'DEAUTHORIZE_BUTTON',
    });
}

export function sendShowAddonItem(params: { itemId: number; skuId: number }) {
    logger.sendShow({
        action: 'VIDEO_ADD_ON_POPUP',
        params: {
            item_id: params?.itemId,
            sku_id: params?.skuId,
        },
    });
}

export function sendClickAddonItem(params: { itemId: number; skuId: number; batchId: number; clickArea: 'cart' | 'buy' }) {
    const clickAreaNum = {
        cart: 0,
        buy: 1,
    }[params.clickArea];

    logger.sendClick({
        action: 'VIDEO_ADD_ON_POPUP',
        params: {
            item_id: params?.itemId,
            sku_id: params?.skuId,
            coupon_id: params?.batchId,
            entrance_source: 1, // 0-其他凑单，1-短视频凑单
            click_area: clickAreaNum, // 0-加购，1-下单
        },
    });
}
